import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import UrlLinkViewModelType from '@/ViewModels/Controls/UrlLinkViewModel';
import LinkType from '@/Controls/Link';
import TextBoxType from '@/Controls/TextBox';
import EventHelper from '@/Utility/EventHelper';

export default class UrlLink extends Control {

    private Link = ComponentManager.getControl<typeof LinkType>('Link');
    private TextBox = ComponentManager.getControl<typeof TextBoxType>('TextBox');
    private jQueryControl: JQuery;
    private link: LinkType;
    private textBox: TextBoxType;

    public constructor(private viewModel: UrlLinkViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');


        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'urllink',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.showLinkOnly) {
            let $a = $('<a target="_blank">');
            EventHelper.ignoreRADEventHandlers($a[0]);

            $a.appendTo(this.jQueryControl);
            this.applyBindings(this.jQueryControl.find('a'), {
                attr: {
                    href: this.viewModel.textBox.value
                },

                text: this.viewModel.textBox.value,
            });
        }
        else {
            if (this.viewModel.textBox != null) {
                this.textBox = new this.TextBox(this.viewModel.textBox);
                let tuple = this.textBox.getTuple();

                tuple.control.appendTo(this.jQueryControl);
            }

            if (this.viewModel.link != null) {
                this.link = new this.Link(this.viewModel.link);
                let tuple = this.link.getTuple();

                tuple.control.appendTo(this.jQueryControl);
            }
        }
    }
}

ComponentManager.setControl('UrlLink', UrlLink, 'RADPresentation.HTMLClient.DefaultViewExtensions');